module.exports = __webpack_public_path__ + "static/atomic-habits-fe2b2e11c50934195e3928baf78c7ea5.jpg";